export default __webpack_public_path__ + "static/media/databases-and-sql-for-data-science.f426658e.png";